import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  button: {
    id: 'component.Layout.Header.CollapsedMenu.button',
    defaultMessage: 'Menu'
  },
  langPL: {
    id: 'component.Layout.Header.CollapsedMenu.langPL',
    defaultMessage: 'Polski'
  },
  langEN: {
    id: 'component.Layout.Header.CollapsedMenu.langEN',
    defaultMessage: 'English'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Header/components/CollapsedMenu/CollapsedMenu.intl.js